// extracted by mini-css-extract-plugin
module.exports = {"numericinput":"NumericInput_numericinput__2Z8tV"};